var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_myClaimApplication_form_editTitle")
        : _vm.$t("label_essweb_approvalProcess_form_claimTitle"),
      widthClass: "max-1000",
      backgroundClass: "transparent",
      pad: "0",
    },
    scopedSlots: _vm._u([
      {
        key: "nav-actions",
        fn: function () {
          return [
            _vm.can_be_cancel &&
            Number(_vm.ClaimApplicationData.approval_status) == 1
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    staticClass: "primary mr-4",
                                    attrs: {
                                      icon: "",
                                      color: "white",
                                      width: "40",
                                      height: "40",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.toCancel.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      size: "24",
                                      fill: "white",
                                      iconClass: "application-cancel",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2890036481
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("label_essweb_form_tools_cancelBtnLabel"))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.ClaimApplicationData &&
            _vm.ClaimApplicationData["flow_status"] == 1
              ? _c("approvalTools", {
                  attrs: {
                    curUuid: _vm.ClaimApplicationData["uuid"],
                    staff_uuid: _vm.curStaff,
                    flag: _vm.ClaimApplicationData["cancel_flag"],
                    data_type: _vm.ClaimApplicationData["data_type"],
                    final_node: Number(
                      _vm.ClaimApplicationData["is_final_task_node"]
                    ),
                    matched: Number(_vm.ClaimApplicationData["is_match"])
                      ? true
                      : false,
                    canRevoke: Number(
                      _vm.ClaimApplicationData["is_allow_revoke"]
                    ),
                    canRollback: Number(
                      _vm.ClaimApplicationData["is_allow_rollback"]
                    ),
                    canForward: Number(
                      _vm.ClaimApplicationData["is_allow_forward"]
                    ),
                  },
                  on: {
                    back: _vm.onBack,
                    forward: _vm.onForward,
                    approval: _vm.onApproval,
                    reject: _vm.onReject,
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _vm.ClaimApplicationData
              ? _c("ApprovalTriger", {
                  attrs: {
                    "bg-color": _vm.ClaimApplicationData.approval_bg_color,
                    "slide-color": _vm.ClaimApplicationData.approval_tint_color,
                    triger:
                      _vm.ClaimApplicationData.approval_status == 1 ||
                      _vm.ClaimApplicationData.approval_status == 2,
                  },
                  on: {
                    triger: function ($event) {
                      _vm.ClaimApplicationData.approval_status == 1 ||
                      _vm.ClaimApplicationData.approval_status == 2
                        ? _vm.$toPage(
                            "/admin/approval-process/claim-detail/" +
                              _vm.$route.params.params +
                              "/approval-detail/" +
                              _vm.$route.params.params
                          )
                        : null
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "time",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getDateTime(
                                    _vm.ClaimApplicationData
                                      .operate_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "status",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.ClaimApplicationData.status_detail
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3319334972
                  ),
                })
              : _vm._e(),
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                items: _vm.taber,
                special: "",
                backgroundColor: "transparent",
                contentBackground: "mrc-grey pa-0",
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "Section",
                        { attrs: { isStart: "" } },
                        [
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          disabled: true,
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          value:
                                            _vm.ClaimApplicationData
                                              .swift_number,
                                          label: _vm.$t(
                                            "label_essweb_myClaimApplication_form_swiftNumberLabel"
                                          ),
                                          dense: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          disabled: true,
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          value: _vm.$getDateTime(
                                            _vm.ClaimApplicationData
                                              .submission_utc_datetime,
                                            "YYYY/MM/DD HH:mm"
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_myClaimApplication_form_createOnLabel"
                                          ),
                                          dense: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          disabled: true,
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimApplicationData
                                              .claim_type_name
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_myClaimApplication_form_claimTypeLabel"
                                          ),
                                          dense: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("AutoComplete", {
                                        attrs: {
                                          label:
                                            "label_essweb_myClaimApplication_form_applicantLabel",
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          "small-chips": !_vm.iSEdited,
                                          disabled: "",
                                          avatar: "",
                                          chips: "",
                                          items: _vm.users,
                                          "item-value": "uuid",
                                          "item-text": "preferred_name",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection.avatar",
                                            fn: function (ref) {
                                              var data = ref.data
                                              return [
                                                _c("StaffAvatar", {
                                                  attrs: {
                                                    left: "",
                                                    small: !_vm.iSEdited,
                                                    isTemp: data.item.is_temp,
                                                    src: data.item.staff_avatar,
                                                    staff_name:
                                                      data.item.preferred_name,
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                          {
                                            key: "selection",
                                            fn: function (ref) {
                                              var data = ref.data
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.preferred_name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value: _vm.user,
                                          callback: function ($$v) {
                                            _vm.user = $$v
                                          },
                                          expression: "user",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Section",
                        { attrs: { iSEdited: _vm.iSEdited, isEnd: "" } },
                        [
                          _c(
                            "v-form",
                            { ref: "form2", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          readonly: !_vm.iSEdited,
                                          disabled: !(
                                            _vm.ClaimApplicationData.field_uuid.indexOf(
                                              "claim_form_name"
                                            ) != -1
                                          ),
                                          filled: _vm.iSEdited,
                                          rules: _vm.$GetRules(
                                            ["_Require_Rules"],
                                            [null]
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_myClaimApplication_form_claimformTitleLabel"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.ClaimApplicationData
                                              .claim_form_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimApplicationData,
                                              "claim_form_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimApplicationData.claim_form_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          readonly: !_vm.iSEdited,
                                          disabled: !(
                                            _vm.ClaimApplicationData.field_uuid.indexOf(
                                              "claim_form_description"
                                            ) != -1
                                          ),
                                          filled: _vm.iSEdited,
                                          label: _vm.$t(
                                            "label_essweb_myClaimApplication_form_descriptionLabel"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.ClaimApplicationData
                                              .claim_form_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimApplicationData,
                                              "claim_form_description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimApplicationData.claim_form_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "pa-0 elevation-0 primary lighten-4 rounded-lg",
                        },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              {
                                staticClass: "text-left text-h6 text--primary",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_ClaimRecord_form_claimTotalAmountLabel"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "text-right text-h5 text--primary",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency_code) +
                                    " " +
                                    _vm._s(
                                      _vm.$get_thousand_num(
                                        parseFloat(
                                          Number(_vm.total_amount).toFixed(4)
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Section",
                        [
                          _c("Tabler", {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.desserts,
                              border: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.type",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.actual_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.actual_currency_code) +
                                        " " +
                                        _vm._s(
                                          _vm.$get_thousand_num(
                                            parseFloat(
                                              Number(
                                                item.actual_amount
                                              ).toFixed(4)
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.claim_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.claim_currency_code) +
                                        " " +
                                        _vm._s(
                                          _vm.$get_thousand_num(
                                            parseFloat(
                                              Number(item.claim_amount).toFixed(
                                                4
                                              )
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.approval_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.currency_code) +
                                        " " +
                                        _vm._s(
                                          _vm.$get_thousand_num(
                                            parseFloat(
                                              Number(
                                                item.approved_amount
                                              ).toFixed(4)
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.action",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    !_vm.iSEdited
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toViewItem(item.uuid)
                                              },
                                            },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                size: "24",
                                                fill: "currentColor",
                                                iconClass: "viewDetail",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    (_vm.iSEdited &&
                                      Number(
                                        _vm.ClaimApplicationData.is_match
                                      ) == 1 &&
                                      Number(
                                        _vm.ClaimApplicationData
                                          .is_application_sequence
                                      ) == 1) ||
                                    (_vm.iSEdited &&
                                      Number(
                                        _vm.ClaimApplicationData.is_match
                                      ) == 1 &&
                                      _vm.ClaimApplicationData["field_uuid"]
                                        .length > 0)
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toEditItem(item.uuid)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("edit")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: { save: _vm.toSave, cancel: _vm.toBack },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("viewClaimItem", {
              attrs: {
                show: _vm.showViewClaimItem,
                isAllowViewAttachments: 1,
                curTypeUuid: _vm.curTypeUuid,
                staff_uuid: _vm.curAppInfo["user"]["user_id"],
                curUuid: _vm.curUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showViewClaimItem = false
                  _vm.curUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }